export default "__VITE_ASSET__C8mwxIoi__"